import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class HmlSubmissionService {

  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  submitHmlFile(fileId: string) {
    let url = `/upload/file/submit/${fileId}/hml`;

    return firstValueFrom(this.http.post(url, {observe: 'response', responseType: 'text'}))
      .catch(this.handleError)
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
